import type { IconPath } from './iconPaths';

export interface IconProps {
  /** Размер в px (иконки DS рисуются в квадрате 24×24 и масштабируются). По умолчанию 16. */
  size?: number;
  className?: string;
  /** Доступное имя. Без него иконка декоративная (aria-hidden). */
  title?: string;
}

export type IconComponent = ((props: IconProps) => React.JSX.Element) & { displayName?: string };

/** Фабрика React-компонента иконки из данных набора VinoWay DS. */
export function createIcon(displayName: string, paths: readonly IconPath[]): IconComponent {
  const body = paths.map((path) => (
    <path
      key={path.id}
      d={path.d}
      transform={path.transform}
      fill="currentColor"
      fillRule="nonzero"
    />
  ));

  function Icon({ size = 16, className, title }: IconProps) {
    if (title) {
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          role="img"
          focusable="false"
          data-icon={displayName}
        >
          <title>{title}</title>
          {body}
        </svg>
      );
    }
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        aria-hidden="true"
        focusable="false"
        data-icon={displayName}
      >
        {body}
      </svg>
    );
  }
  Icon.displayName = displayName;
  return Icon;
}
